<script>
  import { notificationStore } from '../notificationStore.js';
  import { navigate } from 'svelte-routing';
  import { onDestroy } from 'svelte';

  let notification = null; 
  let visible = false;
  let timer;

  const unsubscribe = notificationStore.subscribe(data => {
    if (data) {
      // Normalize data
      if (typeof data === 'string') {
          notification = { message: data };
      } else {
          notification = data;
      }
      
      visible = true;
      if (timer) clearTimeout(timer);

      // Longer timeout for admin messages?
      const duration = notification.type === 'admin' ? 10000 : 5000;
      
      timer = setTimeout(() => {
        visible = false;
        setTimeout(() => notificationStore.set(null), 500);
      }, duration); 
    }
  });

  function handleClick() {
    if (notification && notification.promotionId) {
      navigate(`/promotions/detail/${notification.promotionId}`);
      visible = false;
      notificationStore.set(null);
    }
    // If admin message, clicking just dismisses it
    if (notification && notification.type === 'admin') {
        visible = false;
        notificationStore.set(null);
    }
  }

  onDestroy(() => {
    unsubscribe();
    if (timer) clearTimeout(timer);
  });
</script>

{#if visible && notification}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div 
    class="toast show {notification.type === 'admin' ? 'admin-toast' : ''}" 
    on:click={handleClick} 
    role="button" 
    tabindex="0"
  >
    <div class="icon">
        {notification.type === 'admin' ? '📢' : '🎉'}
    </div>
    <div class="content">
      <div class="message">
          <!-- Ensure we print a string -->
          {typeof notification.message === 'object' ? JSON.stringify(notification.message) : notification.message}
      </div>
      {#if notification.promotionId}
        <div class="hint">Click to view details</div>
      {/if}
    </div>
  </div>
{/if}

<style>
  .toast {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #333;
    color: white;
    padding: 15px 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    z-index: 2000;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.5s, transform 0.5s;
    display: flex;
    align-items: center;
    gap: 15px;
    cursor: pointer;
    max-width: 350px;
    border-left: 5px solid #28a745; /* Green accent */
  }

  .admin-toast {
      background-color: #d63384; /* Pink/Red background for visibility */
      border-left: 5px solid #fff;
  }

  .toast.show {
    opacity: 1;
    transform: translateY(0);
  }

  .icon {
    font-size: 1.5rem;
  }

  .content {
    display: flex;
    flex-direction: column;
  }

  .message {
    font-size: 0.95rem;
    line-height: 1.4;
  }

  .hint {
    font-size: 0.75rem;
    color: #aaa;
    margin-top: 4px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
</style>